import { c as _c } from "react/compiler-runtime";
export default function ToggleViewButtonPlugin(t0) {
  const $ = _c(8);
  const {
    disabled: t1,
    onViewClick
  } = t0;
  const disabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== disabled || $[1] !== onViewClick) {
    t2 = () => {
      if (!disabled) {
        onViewClick();
      }
    };
    $[0] = disabled;
    $[1] = onViewClick;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="tw-sr-only tw-text-sm">Cancel</span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <svg className="tw-h-6 tw-w-6" aria-hidden="true" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor"><path d="M21 14V16.2C21 17.8802 21 18.7202 20.673 19.362C20.3854 19.9265 19.9265 20.3854 19.362 20.673C18.7202 21 17.8802 21 16.2 21H14M10 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V10M15 9L21 3M21 3H15M21 3V9M9 15L3 21M3 21H9M3 21L3 15" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== disabled || $[6] !== t2) {
    t5 = <button onClick={t2} type="button" disabled={disabled} className="tw-relative tw-ml-auto tw-flex tw-h-8 tw-w-8 tw-items-center tw-justify-center tw-rounded-full tw-border-0 tw-bg-transparent tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out hover:tw-bg-iron-900 hover:tw-text-iron-400 focus:tw-outline-none">{t3}{t4}</button>;
    $[5] = disabled;
    $[6] = t2;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
}